import { Outlet } from 'react-router-dom';

import Footer from '../components/Footer';
import MainNavbar from '../components/MainNavbar';
import '../pages/IDProofing.css';

function MainLayout() {
  return (
    <>
          {/* <MainNavbar /> */}
          <div class="bodycontentdisplay">
              <Outlet />
          </div>
          <div class="footerdisplay">
              <Footer />
          </div>

    </>
  );
}

export default MainLayout;
